/**
 * Util method to check if local storage is supported by browser.
 */
const isLocalStorageSupported = () => {
    try {
        return !!window?.localStorage;
    } catch (error) {
        return false;
    }
};

export default isLocalStorageSupported;
